"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.customModel.exceeded': 'Limite modelli IA personalizzati raggiunto. Aggiorna il tuo piano per addestrare più modelli.',
    'limits.customModel.limitReached': 'Limite modello personalizzato: {limit} (aggiorna per addestrarne di più)',
};
